module.exports = __webpack_public_path__ + "assets/img/3de3-dm.svg";